import tictactoe from './tictactoe';

// The only place the site core learns a project exists. Two consumers read it:
// pages/projects.js renders a card per entry, and App.js mounts its route.
// Adding a project is a new folder here plus a line in this list — nothing in
// pages/ or App.js changes.
//
// The live quiz sits in modules/quizapp/ but not in this list: a registry entry
// is one href and one Page, and the quiz needs four routes behind an auth gate
// and its own theme, so App.js routes it itself. See projects.js for its card.
const registry = [tictactoe];

export default registry;
